module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/apple-touch-icon-60.ca37731186cf16a58ff45da0c6a615db.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/apple-touch-icon-60.png
// module id = 1658
// module chunks = 1